export default "__VITE_ASSET__2ovV4N$q__"